// Pinning configuration
export const PINNING_INITIAL_STATE = ["pin"];

// Display values for filters
export const FILTER_DISPLAY_VALUES = (translate) => ({
  trigger: [
    {
      displayName: translate("exceptions-record.filters-display.Manual"),
      value: "Manual",
    },
    {
      displayName: translate("exceptions-record.filters-display.Schedule"),
      value: "Schedule",
    },
  ],
});

// Selected filters display labels
export const SELECTED_FILTERS_DISPLAY = (translate) => ({
  ReconciliationStreamTag: translate("filters-display.StreamName"),
  BusinessDay: translate("filters-display.BusinessDay"),
  AreaId: translate("filters-display.Area"),
  OutletId: translate("filters-display.Outlet"),
  TransactionTerminalCode: translate("filters-display.Terminal"),
  RecordReference: translate("filters-display.RecordReference"),
  RecordDate: translate("filters-display.RecordDate"),
  ReconciliationRunId: translate("filters-display.RunID"),
  NumberOfAttempts: translate("filters-display.NumberOfAttempts"),
  IsInTransitCritical: translate("filters-display.CriticalRecordsOnly"),
  CreationDate: translate("filters-display.CreationDate"),
  AgingTierTag: translate("filters-display.AgingTierTag"),
  SourceAmount: translate("filters-display.SourceAmount"),
  DestinationAmount: translate("filters-display.DestinationAmount"),
  MismatchTag: translate("filters-display.MismatchTag"),
  MismatchSeverityTag: translate("filters-display.MismatchSeverityTag"),
});
